var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BackButton'),(_vm.data)?_c('VideoPage',{attrs:{"data":_vm.data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }